import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import { colors } from '../../styles';

export interface Props {
  className?: string;
  color?: string;
  label?: any;
  left: number;
}

class RangeMarker extends React.Component<Props> {
  public static defaultProps = {
    color: colors.grey300,
  };

  public render() {
    const { className, label } = this.props;
    return (
      <div className={`${className} range-marker`}>
        <div className="marker" />
        <div className="label">{label}</div>
      </div>
    );
  }
}

const StyledRangeMarker = styled(RangeMarker)`
  position: relative;
  display: flex;
  flex-flow: row;
  left: ${props => props.left}px;
  .marker {
    content: '';
    width: 1px;
    height: 100%;
    background: ${props => props.color};
  }
  .label {
    position: absolute;
    bottom: 0;
    left: 5px;
    user-select: none;
    color: ${props => props.color};
  }
`;

export default StyledRangeMarker;
